import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ConfirmLeavePage } from '@src/components/ConfirmLeavePage/ConfirmLeavePage';
import { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
const DefaultDirtyContext = {
    isDirty: false,
    setIsDirty: () => { },
    useMui: false,
    setUseMui: () => { },
};
export const DirtyContext = createContext(DefaultDirtyContext);
export const DirtyContextProvider = ({ children }) => {
    const [isDirty, setIsDirty] = useState(false);
    const [useMui, setUseMui] = useState(false);
    const location = useLocation();
    const value = {
        ...DefaultDirtyContext,
        isDirty,
        setIsDirty,
        useMui,
        setUseMui,
    };
    useEffect(() => {
        setIsDirty(false);
        setUseMui(false);
    }, [location.pathname]);
    return (_jsxs(DirtyContext.Provider, { value: value, children: [children, _jsx(ConfirmLeavePage, { isDirty: isDirty, useMui: useMui })] }));
};
